import React from 'react'
import Navbar from '../components/Navbar'
import HeroSection from "../components/HeroSection"
import AllFlights from '../components/AllFlights'

const Home = () => {
  return (
    <>
    <Navbar />    
    <HeroSection />
    <AllFlights />
    </>
  )
}

export default Home